import { Twitter, Facebook, Link2, Check } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";

/**
 * "Share this post" row. Renders three actions:
 *   - Share on X (intent URL, opens in new tab)
 *   - Share on Facebook (sharer URL, opens in new tab)
 *   - Copy permalink to clipboard
 * Lives next to the Follow row on PostDetailPage.
 */
export default function PostShareLinks({ title }) {
    const [copied, setCopied] = useState(false);
    const pageUrl =
        typeof window !== "undefined" ? window.location.href : "";
    const safeTitle = (title || "").trim();

    const xUrl = `https://x.com/intent/tweet?url=${encodeURIComponent(
        pageUrl,
    )}&text=${encodeURIComponent(safeTitle)}`;
    const fbUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
        pageUrl,
    )}`;

    const copyLink = async () => {
        try {
            await navigator.clipboard.writeText(pageUrl);
            setCopied(true);
            toast.success("Link copied to clipboard");
            setTimeout(() => setCopied(false), 2000);
        } catch {
            toast.error("Couldn't copy link. Long-press the URL bar instead.");
        }
    };

    const btnClass =
        "inline-flex items-center justify-center h-10 w-10 bg-white border border-[#1B1B1B]/15 text-[#1B1B1B] hover:bg-[#F5C53D] hover:border-[#F5C53D] hover:text-[#1B1B1B] transition";

    return (
        <div
            className="mt-3 flex flex-wrap items-center gap-3"
            data-testid="post-share-links"
            aria-label="Share this post"
        >
            <span className="font-poppins text-xs tracking-[0.18em] uppercase text-[#1B1B1B]/60">
                Share
            </span>
            <a
                href={xUrl}
                target="_blank"
                rel="noreferrer"
                aria-label="Share on X"
                title="Share on X"
                className={btnClass}
                data-testid="post-share-x"
            >
                <Twitter className="h-4 w-4" />
            </a>
            <a
                href={fbUrl}
                target="_blank"
                rel="noreferrer"
                aria-label="Share on Facebook"
                title="Share on Facebook"
                className={btnClass}
                data-testid="post-share-facebook"
            >
                <Facebook className="h-4 w-4" />
            </a>
            <button
                type="button"
                onClick={copyLink}
                aria-label="Copy link"
                title="Copy link"
                className={btnClass}
                data-testid="post-share-copy"
            >
                {copied ? (
                    <Check className="h-4 w-4 text-[#1B1B1B]" />
                ) : (
                    <Link2 className="h-4 w-4" />
                )}
            </button>
        </div>
    );
}
